import { render, staticRenderFns } from "./FileFormatActionsRenderer.vue?vue&type=template&id=458b1e9c&"
import script from "./FileFormatActionsRenderer.vue?vue&type=script&lang=ts&"
export * from "./FileFormatActionsRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./FileFormatActionsRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports